import React from "react";

const CseSem7MDU = () => {
  return (
    <>
      <div style={{ backgroundColor: "#Dbe6ea" }}>
        <h1 class="mb-1">
          SEMESTER 7 <br />
          Select Your Subject
          <div class="spinner-grow text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </h1>
      </div>
      <div class="accordion" id="accordionExample">
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingOne">
            <button
              class="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              Advance Computer Architecture
            </button>
          </h2>
          <div
            id="collapseOne"
            class="accordion-collapse collapse show"
            aria-labelledby="headingOne"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/drive/folders/1aIOFh59gDUHTNMEhjV9vw-__yXdKn5Eq?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2013
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/drive/folders/1K9Du5lA1ALY-eJZ0q3ltJFom_qtHMt4z?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2014
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/drive/folders/1h4BOA_OejYcqmuGXc08zlpRbeYJVAWTa?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2015
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1NEThFF8iHLo5OaYJcu86Cxp0aNiGAvod/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2016
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/drive/folders/1v6C6n_kKvpkJL_ITrny8hQCTg8mOdwnV?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2017
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/drive/folders/1FBgtPZel3Kabj8F0oFk4gTt_0uOcNW3K?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2018
                </button>
              </a>
              <br />
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingTwo">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              Distributed Operating System
            </button>
          </h2>
          <div
            id="collapseTwo"
            class="accordion-collapse collapse"
            aria-labelledby="headingTwo"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/file/d/1IMRn2bpDp3dhkT-T5spBcF39SK5QacUQ/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2014
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/drive/folders/1wOVsoEI82tKpV_a3AzgJkUhsEl_L5AEW?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2016
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1b1jFcz3c6IrvjB5ZtPPQqT9604J-0Wq-/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2017
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/drive/folders/1myiL_md1aGijfRCoBueS6sxqKcIKXLvx?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2018
                </button>
              </a>
              <br />
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingThree">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              Compiler Design
            </button>
          </h2>
          <div
            id="collapseThree"
            class="accordion-collapse collapse"
            aria-labelledby="headingThree"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
            <a
                href="https://drive.google.com/drive/folders/1RdfME4XKZVwmdS3nAZVGbca3YDCOAGk9?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2013
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1y7E6FdKzQhK-1xsWsVdR5-fRACJWRNIw/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2014
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1rQkHjaC2YJ3ySDEUtDqZf1Z_oAokkvMo/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2015
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/drive/folders/1UxPgaQ-4bpQpqSDj2YpVINg-XhsyLs01?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2016
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1YgMlggJkux7E3GCJYzzHDzumJQq9-KLz/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2017
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/drive/folders/121p3Rqr0SM9lsuNWwtpGdYtl83my41lM?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2018
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1xQGqzFFPknxdUGEzp3S6SnqjdggXze1H/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2019
                </button>
              </a>
              <br />
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingFour">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFour"
              aria-expanded="false"
              aria-controls="collapseFour"
            >
              Neural Network
            </button>
          </h2>
          <div
            id="collapseFour"
            class="accordion-collapse collapse"
            aria-labelledby="headingFour"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/drive/folders/1Q9yBAkEjsK3vA7lzWk2FrMKOcXaKpNto?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2013
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1b1vh7XMLh9q-S8xH02ko1Is2B9E2zuRh/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2014
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1R9d1IfhMAqxPWdrPXjEnSd2exXb2C-Rx/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2015
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1FV6cbk3P6nVd1Z7cgwBKr9ynM7HSN9pU/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2016
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1lLSauxnuXTmiEQLUQNYTgo_y41FU0Aoc/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2017
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/drive/folders/1MR2fcoULd5o4IyxJpGx8bRhmnAY7ezb7?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2018
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1om7JJkrYq1niA4aaMRjr4j6MXkfTxs4f/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2019
                </button>
              </a>
              <br />
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingFive">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFive"
              aria-expanded="false"
              aria-controls="collapseFive"
            >
              Software Project Management
            </button>
          </h2>
          <div
            id="collapseFive"
            class="accordion-collapse collapse"
            aria-labelledby="headingFive"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/drive/folders/1xFOJeIvJw7TB5vSBwyz3bcIFscG8Suqw?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2014
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1Qrs_lyMpHrR3i855V1ld-sR-R7yw7p6m/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2015
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1tV0S-qGB2OsBARdkQ6FiC7y3mz1zs9Ox/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2016
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1qiHVnVi1_vcvgZZ0lG00Mq4e6TqvJyda/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2017
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1FH0DdmvvmDwkXs5rR2EfCyWlrQK9mzUd/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2018
                </button>
              </a>
              <br />
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingSix">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseSix"
              aria-expanded="false"
              aria-controls="collapseSix"
            >
              Data Warehousing and Data Mining
            </button>
          </h2>
          <div
            id="collapseSix"
            class="accordion-collapse collapse"
            aria-labelledby="headingSix"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/file/d/11Wd4Wr1_VW_396_1olO5eUOs-8vbuM0e/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2017
                </button>
              </a>
              <br />
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 class="accordion-header" id="headingSeven">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseSeven"
              aria-expanded="false"
              aria-controls="collapseSeven"
            >
              Advanced Java
            </button>
          </h2>
          <div
            id="collapseSeven"
            class="accordion-collapse collapse"
            aria-labelledby="headingSeven"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/file/d/1A3d6LaiDpIx58ZDaEIvi8MYNphb7tHFi/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2014
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1_EUtsiZBMtzF2TWE6rtShHxd7613jO6k/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button type="button" className="btn btn-primary">
                  2015
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/drive/folders/11112kKYf_1lNLQvekzfe1c82-N4W0nHi?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2016
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1cOJqBrGTlNSEC64x6ye2NyFEZ1s4iFXH/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button type="button" className="btn btn-primary">
                  2017
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CseSem7MDU;
